import React, { useEffect, useState } from "react";
import { redirect, useNavigate, useParams } from "react-router-dom";
import {
  RecoilState,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
} from "recoil";
import {
  evaluateIndexState,
  evaluationQuestionsListState,
  evaluateArrayIndexSelector,
  canEvaluateSelector,
} from "../../../../recoil/rater/evaluation";
import QuestionNumberBox from "../../../atoms/buttons/QuestionNumberBox";
import EvaluationQuestionsList from "../../../modules/rater/EvaluationQuestionsList";
import RaterComment from "../../../modules/rater/RaterComment";
import { SERVER_IP } from "../../../../static/server";
import { useQuery } from "@tanstack/react-query";
import useExamRoomActions from "../../../../api/hooks/admin/examRoom";
import Select from "../../../atoms/input/Select";
import { examTrim } from "../../../../api/examTrim";

const ExamResult = () => {
  const navigate = useNavigate();

  //시험실 번호 url 파라미터로 가져옴
  const { tester_sn } = useParams();
  const { fetchResultCheckList, fetchRaterResult } = useExamRoomActions();
  const [raterInfo, setRaterInfo] = useState({});
  const evaluateArrayIndex = useRecoilValue(evaluateArrayIndexSelector);
  const [currentItem, setCurrentItem] = useState({});

  const { data: result, isLoading } = useQuery({
    queryKey: ["fetchResultCheckList", tester_sn],
    queryFn: () => fetchResultCheckList({ tester_sn }),
    onSuccess: (res) => {
      if (res.status !== 200) {
        alert("데이터가 없습니다.");
        navigate(-1);
      }

      setEvaluateIndex((old) => {
        return {
          ...old,
          total: res?.data?.answer?.length,
        };
      });
    },
    onError: (res) => {
      console.log("ERR");
    },
  });

  const { data: raterResult } = useQuery({
    queryKey: ["fetchResultCheckList", raterInfo, evaluateArrayIndex],
    enabled: !!(raterInfo.rater_sn && raterInfo.question_sn),
    queryFn: () => {
      return fetchRaterResult({
        tester_sn,
        question_sn: raterInfo.question_sn,
        rater_sn: raterInfo.rater_sn,
      });
    },

    onSuccess: (data) => {
      for (let dataKey in data.data) {
        // console.log("dataKey", dataKey, data.data[dataKey]);
        if (data.data[dataKey].item_type === 1) {
          data.data[dataKey].score = parseInt(data.data[dataKey].score);
        }
      }
      setEvaluationQuestionsList(data.data);
    },
  });

  useEffect(() => {
    if (result?.data.opictester && currentItem.raterList) {
      const { question_sn, raterList } = currentItem;

      if (raterList?.length === 0) {
        setEvaluationQuestionsList([]);
      }

      setRaterInfo((old) => {
        return {
          question_sn,
          rater_sn: raterList[0]?.rater_sn,
        };
      });
    }
  }, [currentItem]);

  useEffect(() => {
    if (result?.data?.examList) {
      for (let item of result?.data?.examList) {
        if (item.exam_number === evaluateArrayIndex + 1) {
          setCurrentItem(item);
        }
      }
    }
  }, [evaluateArrayIndex, result]);

  const canEvaluate = useRecoilValue(canEvaluateSelector);
  //시험실 번호 저장

  //문항 번호
  const [evaluateIndex, setEvaluateIndex] = useRecoilState(evaluateIndexState);

  const setEvaluationQuestionsList = useSetRecoilState(
    evaluationQuestionsListState
  );

  useEffect(() => {
    if (raterInfo.rater_sn && raterInfo.question_sn) {
    }
  }, [raterInfo]);

  const evaluateNumberBox = (evaluateIndex) => {
    //평가 문항 번호 생성 로직
    const rows = [];
    for (let i = 1; i <= result?.data?.examList.length; i++) {
      rows.push(
        <QuestionNumberBox
          key={i}
          index={i}
          active={i === evaluateIndex.current}
          onClick={() =>
            setEvaluateIndex((old) => {
              return {
                ...old,
                current: i,
              };
            })
          }
        />
      );
    }

    return rows;
  };

  return (
    <>
      <link rel="stylesheet" type="text/css" href="/css/rater.css" />

      <div className="rater-section">
        {result?.data?.opictester && !isLoading && (
          <>
            <div className="white-section">
              <div className="student_information">
                <div className="student_profile"></div>
                <div className="student_info">
                  <p className="student_num">
                    <span className="student_title">수험번호</span>
                    <span className="student_cont">
                      {result?.data?.opictester.tester_code}
                    </span>
                  </p>
                  <p className="student-name">
                    <span className="student_title">이름</span>
                    <span className="student_cont">
                      {result?.data?.opictester.name}
                    </span>
                  </p>
                </div>
              </div>
              <div className="border-line"></div>
              <div className="question-number-box">
                {evaluateNumberBox(evaluateIndex)}
              </div>
              <div>
                <p style={{ whiteSpace: "pre-wrap", wordBreak: "break-all" }}>
                  {examTrim(currentItem?.text)}
                </p>
                {result?.data?.answer[evaluateArrayIndex] && (
                  <>
                    <div className="video-box">
                      <video
                        width="100%"
                        controls
                        autoPlay
                        src={`${SERVER_IP}/${result.data.answer[evaluateArrayIndex].url}`}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="white-section">
              <div className="guide-comment text-align-center">
                <p>
                  평가자를 선택하면 해당 평가자의 평가결과를 확인하실 수
                  있습니다.
                </p>
              </div>
              <div>
                <div className="evalation-title" style={{ paddingTop: "20px" }}>
                  {raterInfo.rater_sn && (
                    <>
                      <p
                        style={{ display: "inline-block", marginRight: "10px" }}
                      >
                        평가자명
                      </p>
                      <Select
                        onChange={(e) =>
                          setRaterInfo({
                            rater_sn: e.target.value,
                            question_sn: currentItem.question_sn,
                          })
                        }
                        value={raterInfo}
                        options={[
                          ...currentItem.raterList.map((rater) => {
                            return { value: rater.rater_sn, label: rater.name };
                          }),
                        ]}
                      />
                    </>
                  )}
                </div>

                <EvaluationQuestionsList
                  readOnly={true}
                  evaluated={raterInfo.rater_sn}
                />
                {currentItem.raterList?.length > 0 && (
                  <div className="border-line"></div>
                )}
              </div>
              {tester_sn && currentItem?.question_sn && (
                <RaterComment
                  params={{
                    tester_sn,
                    question_sn: currentItem?.question_sn,
                  }}
                />
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ExamResult;
